export default [
  {
    value: "SINGLE",
    key: "clientCoverages.form.single",
    idInvoicedClient: "defaultInvoicedClientRateSingle",
    idClient: "defaultClientRateSingle",
    idProvider: "defaultProviderRateSingle",
    tpaFee: "defaultTpaFeeSingle",
    gapFee: "defaultGapFeeSingle",
  },
  {
    value: "COUPLE",
    key: "clientCoverages.form.couple",
    idInvoicedClient: "defaultInvoicedClientRateCouple",
    idClient: "defaultClientRateCouple",
    idProvider: "defaultProviderRateCouple",
    tpaFee: "defaultTpaFeeCouple",
    gapFee: "defaultGapFeeCouple",
  },
  {
    value: "FAMILY",
    key: "clientCoverages.form.family",
    idInvoicedClient: "defaultInvoicedClientRateFamily",
    idClient: "defaultClientRateFamily",
    idProvider: "defaultProviderRateFamily",
    tpaFee: "defaultTpaFeeFamily",
    gapFee: "defaultGapFeeFamily",
  },
  {
    value: "SINGLE_PARENT",
    key: "clientCoverages.form.singleParent",
    idInvoicedClient: "defaultInvoicedClientRateSingleParent",
    idClient: "defaultClientRateSingleParent",
    idProvider: "defaultProviderRateSingleParent",
    tpaFee: "defaultTpaFeeSingleParent",
    gapFee: "defaultGapFeeSingleParent",
  },
  {
    value: "WAIVED",
    key: "clientCoverages.form.waived",
    idInvoicedClient: "defaultInvoicedClientRateWaived",
    idClient: "defaultClientRateWaived",
    idProvider: "defaultProviderRateWaived",
    tpaFee: "defaultTpaFeeWaived",
    gapFee: "defaultGapFeeWaived",
  },
];



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/client-coverages/enums/clientCoverageTypes.js